import AnalyticsEvent from '../AnalyticsEvent';
import AnalyticsService from '../AnalyticsService';

export default class ConsoleService implements AnalyticsService {
  constructor(private readonly enabled: boolean) {}

  async connect() {
    // eslint-disable-next-line no-console
    this.enabled && console.log('[Analytics] Console output enabled.');
  }

  report(event: AnalyticsEvent) {
    // eslint-disable-next-line no-console
    this.enabled && console.log('[Analytics] Reporting event', event);
  }
}
